module.exports = __webpack_public_path__ + "static/Sonja-6f29ec323c633cc003a570af59664619.jpg";